import React, { useState } from "react";
import { sortDropdownInterface } from "../../../../../types/type";
import { SORT_TYPE } from "../../../../../types/enum";
import { useTranslation } from "../../../../../shared/hooks/useTranslation";
import {
  getSortTypeText,
  getSortTypeOptions,
} from "../../../../../shared/utils/sort-utils";

export default function SortDropDown(props: sortDropdownInterface) {
  const { t } = useTranslation();
  const sortOptions = getSortTypeOptions(t);
  const [isOpened, setIsOpened] = useState(false);

  const handleToggleDropdown = () => {
    setIsOpened(!isOpened);
  };

  const handleSelectOption = (optionKey: SORT_TYPE) => {
    props.handleSelectedSortType(optionKey);
    setIsOpened(false);
  };

  // TODO open 되었을 때 dropdown width 안맞음
  return (
    <section className="sort-drop-down">
      <button
        className={
          isOpened ? "drop-down-btn drop-down-btn-active" : "drop-down-btn"
        }
        onClick={handleToggleDropdown}
      >
        <div>{getSortTypeText(props.selectedType, t)}</div>
        <img src={"/assets/icons/CkChevronDown.svg"} alt="drop-down" />
      </button>
      {isOpened ? (
        <div
          className={
            isOpened
              ? "drop-down-list slide-fade-in-dropdown"
              : "drop-down-list slide-fade-out-dropdown"
          }
        >
          {sortOptions.map((option) => {
            return (
              <div
                key={option.key}
                onClick={() => handleSelectOption(option.key)}
                className={
                  option.key === props.selectedType
                    ? "drop-down-elements selected-element"
                    : "drop-down-elements"
                }
              >
                {option.text}
              </div>
            );
          })}
        </div>
      ) : null}
    </section>
  );
}
